


















import { debounceProcess } from "@/helpers/debounce";
import useBank from "@/hooks/useBank";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { ListCompanyBankDto } from "@/models/interface/company-bank";
import { LabelInValue } from "@/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SelectCompanyBank extends Vue {
  @Prop({ required: false, default: undefined })
  value!: LabelInValue;

  @Prop({ required: false, type: Boolean, default: false })
  disabled!: boolean;

  options: Option<ListCompanyBankDto>[] = [];
  loading = false;

  created(): void {
    this.onSearch = debounceProcess(this.onSearch);

    this.fetchOptions();
  }

  fetchOptions(params: RequestQueryParams = new RequestQueryParams()): void {
    const { findAll, toOptions } = useBank();
    this.loading = true;
    findAll(params)
      .then(res => {
        this.options = toOptions(res.data);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onChange(e?: LabelInValue): void {
    if (!e) {
      this.fetchOptions();
    }

    this.$emit("input", e);
    this.$emit("change", e);
    this.$emit("update:meta", this.findOption(e));
  }

  onSearch(val = ""): void {
    const { searchBy } = useBank();
    const params = new RequestQueryParams();
    params.search = searchBy({
      bankAccName: val,
      bankAccNumber: val,
      bankName: val,
    });

    this.fetchOptions(params);
  }

  findOption(value?: LabelInValue): Option<ListCompanyBankDto> | undefined {
    return this.options.find(e => value?.key === e.value);
  }
}
